<template>
  <div :class="$setClasses">
    <div :class="$vClass('body')">
      <nxt-core-input-number v-model="field.value"
                             :disabled="field.disabled"
                             :height="42"
                             :input-id="inputId"
                             :label="$t('base.calcVolume')"
                             :min="field.min || 0"
                             :placeholder="field.placeholder || field.display_name"
                             :required="field.required"
                             :width="100"
                             ceil
                             displayInput
                             @change="saveVolume($event)"
                             @decrease="saveVolume($event, true)"
                             @focusout="saveVolume($event, true)"
                             @increase="saveVolume($event, true)"/>
      <div>
        <nxt-core-btn :class="['nxt-button nxt-button__white', $vClass('body__button')]"
                      :disabled="field.disabled"
                      :title="$t('base.calcVolume')"
                      type="button"
                      @click="openModal(true)"/>
      </div>
    </div>
    <furniture-modal :field="field"
                     :visible="displayCustomFurnitureModal"
                     @visibilityChange="openModal(false)"/>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useFurnituresStore } from '@nextories/vue-core-components/src/store/furnituresStore.ts';

export default {
  name: 'Volume',
  nameClassStyle: 'volume',
  emits: ['changedValue'],
  props: {
    field: Object,
    inputId: String,
  },
  data() {
    return {
      displayCustomFurnitureModal: false,
    };
  },
  computed: {
    ...mapState(useFurnituresStore, ['volume']),
  },
  methods: {
    ...mapActions(useFurnituresStore, [
      'setVolume',
    ]),
    openModal(e) {
      this.displayCustomFurnitureModal = e;
      document.body.classList[e ? 'add' : 'remove']('u-overflow-hidden');
    },
    saveVolume(volume, changedValue) {
      if (this.$helpers.format.isNumber(volume)) {
        if (changedValue) {
          this.$emit('changedValue');
        }
        this.setVolume(volume);
        this.field.value = this.volume;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.#{$prefixName}volume {
  &__body {
    & {
      display: grid;
      gap: var(--nxt-space-small) var(--nxt-space-medium);
    }

    &__button {
      margin: 0;
      font-size: 14px;
      font-weight: 700;
    }

    @include breakpoint(mobileWithHeight) {
      display: flex;
      align-items: center;
    }
  }
}
</style>
